import type { ReactElement, ReactNode } from 'react';
import { Box, DialogBody, DialogFooter, Grid } from '@ff-it/ui';
import * as styles from './BuilderWorkspace.css';

export const builderColumns = { default: 'minmax(0, 1fr)', lg: '240px minmax(0, 1fr)' } as const;

export type BuilderWorkspaceProps = {
  sidebar: ReactNode;
  children: ReactNode;
  close: ReactNode;
  actions: ReactNode;
  footerLabel: string;
  disabled?: boolean;
};

export function BuilderWorkspace({
  sidebar,
  children,
  close,
  actions,
  footerLabel,
  disabled,
}: BuilderWorkspaceProps): ReactElement {
  return (
    <>
      <DialogBody p="0" flexGrow={1} className={styles.body} minHeight="0">
        <Grid
          as="fieldset"
          disabled={disabled}
          gridTemplateColumns={builderColumns}
          gap="0"
          height={{ default: 'auto', lg: 'full' }}
          minHeight="0"
          minWidth="0"
          borderStyle="none"
          p="0"
          m="0"
        >
          {sidebar}
          <Box className={styles.detail}>{children}</Box>
        </Grid>
      </DialogBody>
      <DialogFooter as="footer" aria-label={footerLabel} className={styles.footer}>
        <Grid gridTemplateColumns={builderColumns} gap={{ default: '2', lg: '0' }} alignItems="center" width="full">
          <Box>{close}</Box>
          {actions}
        </Grid>
      </DialogFooter>
    </>
  );
}
